import { useEffect, useRef } from 'react'

import { useDrawerGuard } from './DrawerGuardContext'

interface DrawerDirtyGuardProps {
    /** true — у формі є введені й не збережені дані; закриття спершу питає підтвердження */
    isDirty: () => boolean
}

/**
 * Реєструє в AppDrawer перевірку незбережених змін для власних форм (не карток ресурсу,
 * де це робить DetailShell). Рендерити всередині AppDrawer; нічого не малює.
 */
export const DrawerDirtyGuard = ({ isDirty }: DrawerDirtyGuardProps) => {
    const guardApi = useDrawerGuard()
    // Найсвіжіша перевірка без перереєстрації на кожен рендер
    const isDirtyRef = useRef(isDirty)
    isDirtyRef.current = isDirty

    useEffect(() => {
        if (!guardApi) return undefined
        guardApi.setGuard(() => {
            try {
                return isDirtyRef.current()
            } catch (error) {
                // Порівняння не має блокувати закриття
                console.warn('[DrawerDirtyGuard] Не вдалося перевірити зміни', error)
                return false
            }
        })
        return () => guardApi.setGuard(null)
    }, [guardApi])

    return null
}
